<ion-content>
  <ion-nav [root]="root" [rootParams]="{
    title: this.title,
    singularTitle: this.singularTitle,
    plural: this.plural,
    description: this.description,
    buttonText: this.buttonText,
    hasItemForm: this.hasItemForm,
    listedData: this.listedData
  }"></ion-nav>
</ion-content>
